import React from 'react';
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import {graphql, Link, useStaticQuery} from "gatsby";
import {Trans} from "gatsby-plugin-react-i18next";
import {getLangs} from "./common";

const {languages, defaultLanguage, allLanguages} = require('../../languages');

function Sidebar({pageContext}) {

    const query = graphql`
      query {
        allStrapiPost(sort: {createdAt: DESC}) {
            group(field: {locale: SELECT}, limit: 5) {
              nodes {
                strapi_id
                locale
                slug
                Title
                cover {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
              }
            }
          }
          allStrapiCwCountry(sort: {name: ASC}) {
            nodes {
              name
              slug
              country
              locale
            }
          }
          allStrapiCwRegion(sort: {name: ASC}) {
            nodes {
              name
              slug
              region
              locale
            }
          }
          allStrapiCwTopic(sort: {name: ASC}) {
            nodes {
              name
              slug
              topic
              locale
            }
          }
      }
`;

    const data = useStaticQuery(query);

    let recentPosts = [];
    const recentPostsGroup = data.allStrapiPost?.group ?? [];
    const countries = (data.allStrapiCwCountry?.nodes ?? []).filter((item) => item.locale === pageContext.language);
    const regions = (data.allStrapiCwRegion?.nodes ?? []).filter((item) => item.locale === pageContext.language);
    const topics = (data.allStrapiCwTopic?.nodes ?? []).filter((item) => item.locale === pageContext.language);
    let postGroupIndex = null;
    for (const [index, group] of recentPostsGroup.entries()) {
        if (postGroupIndex === null && group.nodes?.[0]?.locale === pageContext.language) {
            postGroupIndex = index;
        }
    }
    if (postGroupIndex !== null) {
        recentPosts = recentPostsGroup?.[postGroupIndex]?.nodes ?? [];
    }

    const langs = getLangs(pageContext, {}, true);
    // console.log('langs', langs);

    return (
        <div className="sidebar">
            {/*<div className="sidebar__single sidebar__search">
                                    <form action="#" className="sidebar__search-form">
                                        <input type="search" placeholder="Search">
                                            <button type="submit"><i className="tripo-icon-magnifying-glass"></i></button>
                                    </form>
                                </div>*/}
            {!!recentPosts.length && (<div className="sidebar__single sidebar__post">
                <h3 className="sidebar__title"><Trans>Recent Posts</Trans></h3>
                <ul className="sidebar__post-list list-unstyled">
                    {recentPosts.map((post) => (
                        <li key={post.strapi_id}>
                            <Link
                                to={`/${post.locale}/post/${post.slug}`}
                            >
                                {post.cover && (
                                    <div className="sidebar__post-image">
                                        <GatsbyImage
                                            image={getImage(post.cover?.localFile)}
                                            alt={post.cover?.alternativeText ?? "Find-My-Beach"}
                                        />
                                    </div>
                                )}
                                <div className="sidebar__post-content">
                                    <h3>{post.Title}</h3>
                                </div>
                            </Link>
                        </li>))}
                </ul>
            </div>)}
            {!!countries?.length && (
                <div className="sidebar__single sidebar__category">
                    <h3 className="sidebar__title"><Trans>Countries</Trans></h3>
                    <ul className="sidebar__category-list list-unstyled">
                        {countries.map((item) => (
                            <li key={item.slug}><a
                                href={`/${pageContext.language}/blog/country-${item.slug}`}>{item.name}</a></li>
                        ))}
                    </ul>
                </div>)}
            {!!regions?.length && (
                <div className="sidebar__single sidebar__category">
                    <h3 className="sidebar__title"><Trans>Regions</Trans></h3>
                    <ul className="sidebar__category-list list-unstyled">
                        {regions.map((item) => (
                            <li key={item.slug}><a
                                href={`/${pageContext.language}/blog/region-${item.slug}`}>{item.name}</a></li>
                        ))}
                    </ul>
                </div>)}
            {!!topics?.length && (
                <div className="sidebar__single sidebar__category">
                    <h3 className="sidebar__title"><Trans>Topics</Trans></h3>
                    <ul className="sidebar__category-list list-unstyled">
                        {topics.map((item) => (
                            <li key={item.slug}><a
                                href={`/${pageContext.language}/blog/topic-${item.slug}`}>{item.name}</a></li>
                        ))}
                    </ul>
                </div>)}
            {langs.length > 0 && (
                <div className="sidebar__single sidebar__category">
                    <h3 className="sidebar__title"><Trans>Read on other languages</Trans></h3>
                    <ul className="sidebar__category-list list-unstyled">
                        {Object.keys(pageContext.alternates).map((lang) => (
                            <li key={lang}><a
                                href={`${pageContext.alternates[lang].url}`}>{pageContext.alternates[lang].title ?? allLanguages.find((item) => item.code === lang)?.name ?? 'unknown'}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
            <div className="sidebar__single sidebar__social">
                <h3 className="sidebar__title">Follow Us</h3>
                <div className="sidebar__social-list">
                    <a href="https://www.facebook.com/Find-My-Beach-110276687409669" target={"_blank"}><i
                        className="fab fa-facebook-square"></i></a>
                    <a href="https://www.instagram.com/find.my.beach/" target={"_blank"}><i
                        className="fab fa-instagram"></i></a>
                    <a href="mailto:info@find-my-beach.com" target={"_blank"}><i
                        className="fab fa fa-envelope"></i></a>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
